import { render, staticRenderFns } from "./newReply.vue?vue&type=template&id=348585a4&scoped=true"
import script from "./newReply.vue?vue&type=script&lang=js"
export * from "./newReply.vue?vue&type=script&lang=js"
import style0 from "./newReply.vue?vue&type=style&index=0&id=348585a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348585a4",
  null
  
)

export default component.exports